<script setup>

import CloseButton from '../components/CloseButton.vue'
import NavButton from '../components/NavButton.vue'
import FieldsTableRow from '../components/FieldsTableRow.vue'
import {computed} from "vue";
import { store } from "@/store";

const isCouple = computed({
  get() { return store.formData.user.isCouple },
  set(val) {
    // Changing isCouple via the modal resets standard slider values
    const scKey = val ? 'presetsCouple' : 'presetsSingle';
    for (const standard of store.formData.standards) { standard.value = standard[scKey].mod }
    store.formData.standardTotal.value = store.formData.standardTotal[scKey].mod;
    store.formData.user.isCouple = val;
  }

})
</script>

<template>
  <div class="modal-2609 modal__sc">
    <div class="m__content">
      <CloseButton v-on:click="store.closeModal()">Close</CloseButton>

      <div class="fields-table no-labels">
        <table>
          <tbody>
            <FieldsTableRow v-bind:label="''">
              <input type="radio" id="single" v-bind:value="false" v-model="isCouple">
              <label for="single"><span><span></span></span>Model as a single person</label>
              <input type="radio" id="couple" v-bind:value="true" v-model="isCouple">
              <label for="couple"><span><span></span></span>Model as a couple</label>
            </FieldsTableRow>
          </tbody>
        </table>
      </div>

      <div class="nav-bar">
        <NavButton dir=">" class="no-pn" v-on:click="store.formState.page = 'customStandard'; store.formState.modal = false">Next</NavButton>
      </div>
    </div>
  </div>
</template>
